export const year_current = {
    year: '2023-current',
    role: 'Software Engineering Manager',
    company: 'Vail Systems',
    text: 'Contribute to and manage feature development, deployments, and maintenance of Ruby on Rails application with Typescript frontend.'
}

export const year_2022 =
    {
    year: '2022',
    role: 'Frontend Engineer',
    company: 'Vail Systems',
    text: 'Support feature development and ongoing maintenance of Ruby on Rails application with React frontend.',
    }
        
export const year_2021 =
    {
    year: '2021',
    role: 'Frontend Engineer',
    company: 'Vail Systems',
    text: 'Support feature development and ongoing maintenance of Ruby on Rails application with React frontend.'
    }

export const year_2020 =
    {
    year: '2020',
    role: 'UX Designer',
    company: 'Vail Systems',
    text: 'Led product design and UX for consumer-facing telecommunications API. Managed the professional development of new UX researcher.'
    }

export const year_2019 =
    {
    year: '2019',
    role: 'UX Designer',
    company: 'Vail Systems',
    text: 'Led the creation and management of a new product design internship, resulting in the successful hiring of graduate-level UX researcher and designer.'
    }

export const year_2018 =
    {
    year: '2018',
    role: 'UX Designer',
    company: 'Vail Systems',
    text: 'Work closely with product and engineering to design B2B telecommunications software.'
    }

export const year_2017 =
    {
    year: '2017',
    role: 'Cofounder',
    company: 'Minda Labs',
    text: 'Led product vision, business development, and product management for virtual reality-based learning platform. Worked closely with academics and researchers at Yale, Stanford, and Harvard to understand student needs and learning objectives, and translate into feature set. Prioritized tasks and managed technical implementation for on-time deployment. Successfully launched paid pilots to over 1,200 students during Fall 2018.'
    }

export const year_2016 =
    {
    year: '2016',
    role: 'Product Designer',
    company: 'Enigma',
    text: 'Worked on all design aspects of enterprise-level data management ecosystem. Defined team-wide UX principles. Led product research, user interviews, and user testing. Lead designer on relaunch of Enigma Public, redesigning onboarding and initial user flows resulting in a 200% increase in daily active users.'
    }

export const year_2015 =
    {
    year: '2015',
    role: 'Product Designer',
    company: 'Chartbeat',
    text: 'Collaborated on UX and visual design of our enterprise-level analytics tools and dashboards for editorial teams. Contributed to product research, user interviews, and user testing.'
    }
        
export const year_2014 =
    {
    year: '2014',
    role: 'Marketing Web Designer',
    company: 'Chartbeat',
    text: 'Redefined visual brand, maintained style guide, created illustrations for Twitter campaigns, collateral, and public-facing website. Redesigned and collaborated to build the public-facing website.'
    }